const MuiCssBaseline = {
  '@global': {
    html: { fontSize: '14px' },
    body: { backgroundColor: '#fff' },
    h1: { textAlign: 'left' },
    h2: { textAlign: 'left' },
    p: { textAlign: 'left' },
  },
}

export default MuiCssBaseline
